import React, { useState, useEffect } from 'react';
import './Navbar.css';
import logoPHSchool from '../assets/logo/logo_PHSchool.png';

export default function Navbar({
  headerMenu = [],
  activeItemId,
  onSelectSlug,
  goToSlug,
  goToHomepage,
  getSubmenuItemsForNavItem,
  goToSection,
  loadingMenu
}) {
  const [openMenuId, setOpenMenuId] = useState(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Fallback menu items if API doesn't return data
  const fallbackMenu = [
    { id: 'about', title: 'About Us', slug: 'about-us' },
    { id: 'education', title: 'Education Program', slug: 'education-program' },
    { id: 'admissions', title: 'Admissions', slug: 'admissions' },
    { id: 'student-life', title: 'Student Life', slug: 'student-life' },
    { id: 'facilities', title: 'Facilities', slug: 'facilities' },
    { id: 'news', title: 'News and Updates', slug: 'news-updates' },
    { id: 'parents', title: 'Parents', slug: 'parents' },
    { id: 'careers', title: 'Careers', slug: 'careers' }
  ];

  const menuToRender = headerMenu && headerMenu.length > 0 ? headerMenu : fallbackMenu;

  console.log('[Navbar] Rendering with headerMenu:', headerMenu);
  console.log('[Navbar] loadingMenu:', loadingMenu);
  console.log('[Navbar] menuToRender:', menuToRender);

  // Handle menu click - scroll to top
  const handleMenuClick = (item) => {
    console.log('[Navbar] Menu clicked:', item);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onSelectSlug(item);
  };

  // Handle submenu click - scroll to section top
  const handleSubmenuClick = (child) => {
    console.log('[Navbar] Submenu clicked:', child);
    if ('anchor' in child) {
      goToSection(child.slug, child.anchor);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      onSelectSlug(child);
    }
  };

  return (
    <>
      <header className="navbar-header">
        <nav className="navbar">
          {/* Logo */}
          <button className="navbar-logo" onClick={goToHomepage} type="button">
            <img src={logoPHSchool} alt="PHS" />
          </button>

          {/* Desktop Menu */}
          <ul className="navbar-menu">
            {!loadingMenu &&
              menuToRender
                .filter(
                  (item) =>
                      item.slug !== 'homepage'
                )
                .map((item) => {
                  const submenuItems = getSubmenuItemsForNavItem(item);
                  return (
                    <li
                      key={item.id || item.slug}
                      className="navbar-menu-item"
                      onMouseEnter={() => setOpenMenuId(item.id)}
                      onMouseLeave={() => setOpenMenuId(null)}
                    >
                      <button
                        className={`navbar-menu-link ${activeItemId === item.id ? 'active' : ''}`}
                        onClick={() => handleMenuClick(item)}
                        type="button"
                      >
                        {item.title}
                      </button>
                      {submenuItems.length > 0 && (
                        <ul className={`navbar-submenu ${openMenuId === item.id ? 'open' : ''}`}>
                          {submenuItems.map((child) => (
                            <li key={child.id || child.title}>
                              <button
                                className={`navbar-submenu-link ${
                                  activeItemId === child.id ? 'active' : ''
                                }`}
                                onClick={() => handleSubmenuClick(child)}
                                type="button"
                              >
                                {child.title}
                              </button>
                            </li>
                          ))}
                        </ul>
                      )}
                    </li>
                  );
                })}
          </ul>

          {/* Right Actions */}
          <div className="navbar-actions">
            <button 
              className="navbar-btn-contact" 
              onClick={() => {
                window.scrollTo({ top: 0, behavior: 'smooth' });
                goToSlug('contact-us');
              }}
              type="button"
            >
              Contact us
            </button>
            <button
              className={`navbar-toggle ${isMobileMenuOpen ? 'open' : ''}`}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              type="button"
              aria-label="Menu"
            >
              <span></span>
              <span></span>
              <span></span>
            </button>
          </div>
        </nav>
      </header>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="navbar-mobile-menu">
          <ul>
            {!loadingMenu &&
              menuToRender
                .filter(
                  (item) =>
                    item.slug !== 'homepage' &&
                    item.slug !== 'contact-us' &&
                    !String(item.title || '').toLowerCase().includes('contact')
                )
                .map((item) => (
                  <li key={item.id || item.slug}>
                    <button
                      onClick={() => {
                        window.scrollTo({ top: 0, behavior: 'smooth' });
                        onSelectSlug(item);
                        setIsMobileMenuOpen(false);
                      }}
                      type="button"
                    >
                      {item.title}
                    </button>
                  </li>
                ))}
          </ul>
          <button
            className="navbar-btn-contact"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: 'smooth' });
              goToSlug('contact-us');
              setIsMobileMenuOpen(false);
            }}
            type="button"
          >
            Contact us
          </button>
        </div>
      )}
    </>
  );
}
